import { render, staticRenderFns } from "./m-simulation-detail.vue?vue&type=template&id=2e058d9c"
import script from "./m-simulation-detail.vue?vue&type=script&lang=js"
export * from "./m-simulation-detail.vue?vue&type=script&lang=js"
import style0 from "./m-simulation-detail.vue?vue&type=style&index=0&id=2e058d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports